/* eslint-disable react/react-in-jsx-scope */
import { store } from 'redux/store';
import Swal from 'sweetalert2';
import i18n from 'i18n/config';

import { format } from 'date-fns';
import { deleteDraft } from 'modules/drafts/redux/draftActions';
import { dateFormat } from 'constants/formats';
import { setModal } from 'modules/_shared/redux/modalActions';

import updateNcStatus from 'utils/updateNcStatus';
import RenameDraft from 'modules/_shared/components/Modals/RenameDraft';

export default [
  {
    icon: 'ni-edit-alt',
    text: i18n.t('Rename'),
    action: ({ data: draft }) => {
      store.dispatch(setModal(<RenameDraft draft={draft} />));
    },
    dontShowCurrent: ({ isReadOnly }) => isReadOnly,
  },
  {
    icon: 'ni-edit',
    text: i18n.t('EditState'),
    action: updateNcStatus,
    dontShowCurrent: ({ isReadOnly }) => isReadOnly,
  },
  {
    icon: 'ni-trash',
    text: i18n.t('Delete'),
    action: ({ draftId, data: draft }) => {
      const formattedDate = format(new Date(draft?.date), dateFormat);
      Swal.fire({
        icon: 'warning',
        title:
          '<h4 class="nk-modal-title">¿Está seguro de que desea eliminar este borrador?</h4>',
        html: `<h5 class="text-primary">${formattedDate} | ${draft?.name}</h5><br /><div class="caption-text">Este procedimiento no se puede deshacer.</div>`,
        confirmButtonText: 'Ok, eliminar',
        confirmButtonColor: '#6576ff',
        allowOutsideClick: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          store.dispatch(deleteDraft(draftId));
        }
      });
    },
    dontShowCurrent: ({ isReadOnly }) => isReadOnly,
  },
];
